import { Alert, AlertDescription } from "@zapier/design-system";
import { Button } from "@zapier/design-system-beta";
import styles from "./AppChangeWarning.module.css";

type Props = {
  onConfirm: () => void;
  onDismiss: () => void;
  isRemovingApp: boolean;
};

export function AppChangeWarning({
  onConfirm,
  onDismiss,
  isRemovingApp,
}: Props) {
  return (
    <div className={styles.root}>
      <Alert
        onDismiss={onDismiss}
        status="warning"
        title={`${isRemovingApp ? "Removing" : "Changing"} this app will delete any notes or link attached to it.`}
      >
        <AlertDescription>Do you wish to continue?</AlertDescription>
        <div className={styles.buttonWrapper}>
          <Button variant="tertiary" size="small" onPress={onDismiss}>
            Cancel
          </Button>
          <Button variant="primary" size="small" onPress={onConfirm}>
            Confirm
          </Button>
        </div>
      </Alert>
    </div>
  );
}
